module.exports = __webpack_public_path__ + "img/icon-renegades-le_mclarenplus.a943080.png";